import { useTranslation } from 'react-i18next'
import { SheetModal } from '../sheet-modal'
import { useWindowActions } from '../../../../models/window'
import CoinIcon from '../../../friends/item/assets/images/coin.png'

import c from './referral-welcome-modal.module.scss'

const ReferralWelcomeModal = ({ referrerUsername }) => {
    const { t } = useTranslation()
    const { closeWindow } = useWindowActions()

    const handleButtonClick = () => {
        closeWindow()
    }

    return (
        <SheetModal>
            <div className={c.component}>
                <div className={c.header}>
                    <img src="/images/bonus.png" alt="poster" />
                </div>
                <div className={c.main}>
                    <p className={c.title}>
                        {t('modal.referralWelcome.title')}
                    </p>
                    <p className={c.subtitle}>
                        {t('modal.referralWelcome.subtitle')}
                    </p>
                    <div className={c.list}>
                        <p className={c.item}>
                            {t('modal.referralWelcome.invitedBy')}{' '}
                            {referrerUsername
                                ? `@${referrerUsername}`
                                : t('modal.referralWelcome.invitedByFallback')}
                        </p>
                        <p className={c.item}>
                            {t('modal.referralWelcome.reward')}{' '}
                            <img
                                src={CoinIcon}
                                alt="coin"
                                className={c.coinIcon}
                            />
                        </p>
                    </div>
                </div>
                <div className={c.bottom}>
                    <button
                        type="button"
                        className={c.btn}
                        onClick={handleButtonClick}
                    >
                        <span>{t('modal.referralWelcome.button')}</span>
                    </button>
                </div>
            </div>
        </SheetModal>
    )
}

export default ReferralWelcomeModal
